import moment from "moment";
import { Link } from "react-router-dom";
import { CheckBox } from "../../../components/CheckBox";
import { routeBuilder } from "../../../utils/routeBuilder";
import { TextField } from '@mui/material';
import { Grid, IconButton, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import ClearIcon from "@material-ui/icons/Clear";
import dayjs from "dayjs";
import Template from "../../../components/Template";
import { poAllocationListStrings, poDispatchStrings, purchaseOrderStrings, commonStrings, dispatchInfoStrings } from "../../../components/StringBundle";
import {convertDayJsToRawFormat, createColumnsFromBundle, dateFormat, formatDateSafe, formatNumber, getCompanyFilterList, isCompanyRestrictedRole, mapObjectToArray, numberWithCommas, viewDataStructure} from "../../common";
import { roles } from "../../../constants/roles";
import VehicleInformationTab from "../DispatchNew/VehicleInformationTab";
import { filterTableSorter } from "../../../components/TableCustomSort";

const docHeaderLabels = purchaseOrderStrings.dispatch.documentInfoTableHeaders;
const dispatchString = purchaseOrderStrings.dispatch;
const dispatchTableHeaders = purchaseOrderStrings.dispatch.dispatchTableHeaders;
const documentNumberLabelMapStr = purchaseOrderStrings.dispatch.documentNumberLabelMap;
const docKindFieldsStr = purchaseOrderStrings.dispatch.docKindFields;
const poForms = purchaseOrderStrings.forms;

export const allocationColumns = [
    { 
      title: poAllocationListStrings.allocationRecordNo,
      dataIndex: 'record_id',
      key: 'record_id',
      width: '15%',
      render: (text, record) => (
       <Link  to={`/allocation/${encodeURIComponent(record?.record_id)}/view` }>{text}</Link>
      ),
    },
    {
      title: poAllocationListStrings.quoteNo,
      dataIndex: 'quote_number',
      key: 'quote_number',
      width: '15%',
    },
    {
      title: poAllocationListStrings.quoteLineNumber,
      dataIndex: 'quote_line_number',
      key: 'quote_line_number',
      width: '15%',
    },
    {
      title: poAllocationListStrings.accountName,
      dataIndex: 'account_name',
      key: 'account_name',
      width: '15%',
    },
    {
      title: poAllocationListStrings.poNo,
      dataIndex: 'pono',
      key: 'pono',
      width: '15%'
    },
    {
      title: poAllocationListStrings.itemName,
      dataIndex: 'item_name',
      key: 'item_name',
      width: '15%',
      render: (text, record) => (
        <Link  to={routeBuilder('gc',record?.item_id,'view')}>{text}</Link>
      ),
    },
    {
      title: poAllocationListStrings.allocatedQty,
      dataIndex: 'allocated_quantity',
      key: 'allocated_quantity',
      width: '15%',
    },
    {
      title: poAllocationListStrings.allocationDate,
      dataIndex: 'allocated_date',
      key: 'allocated_date',
      width: '15%',
    }
  ];

export const GetPurchaseColumns = {
    currencyPayload2: (className,purchaseDetails) => {
        const isPaymentAgainstDelivery = purchaseDetails?.details?.payment_against_delivery;
        return [
        {
          type: "label",
          value: poForms.noOfDaysIOM,
          bold: true,
          sm: "12",
          className: className,
          md: "12",
        },
        {
          type: "label",
          value: purchaseDetails?.details?.payment_terms_days,
          sm: "12",
          md: "12",
        },
        // Show "Payment Against Delivery" checkbox label when selected
        ...(isPaymentAgainstDelivery ? [
          {
            type: "label",
            value: poForms.paymentAgainstDelivery,
            bold: true,
            sm: "12",
            className: className,
            md: "12",
          },
          {
            type: "checkbox",
            checked: true,
            disabled: true,
            sm: "12",
            md: "12",
          },
        ] : [
          // Show "No of days from receipt of material" only when Payment Against Delivery is NOT selected
          {
            type: "label",
            value: poForms.noOfDays,
            bold: true,
            sm: "12",
            className: className,
            md: "12",
          },
          {
            type: "label",
            value: purchaseDetails?.details?.payment_terms || "-",
            md: "12",
            sm: "12",
          },
        ]),
        {
          type: "label",
          value: poForms.paymentTermsRemarks,
          bold: true,
          className: className,
          md: "12",
          sm: "12",
        },
        {
          type: "label",
          value: purchaseDetails?.details?.payment_term_remarks || "-",
          md: "12",
          sm: "12",
        },
      ]
    },
};

// PO list filter session storage keys
export const STORAGE_KEYS = {
  company: "purchaseOrderCompany",
  status: "POfilterState",
  entity: "POfilterEntity",
  category: "POfilterCategory",
  itemType: "POfilterItemType",
  shipmentMonthFrom: "POfilterShipmentMonthFrom",
  shipmentMonthTo: "POfilterShipmentMonthTo",
};

// Reads a filter value from session storage, treating the "All" sentinel as unset
export function readFilter(key) {
  const saved = sessionStorage.getItem(key);
  return saved && saved !== commonStrings.all ? saved : null;
}

// left over from before the status filter switched to storing the lov_name.
export function readStatusFilter(key) {
  const saved = readFilter(key);
  return saved && /^PO-ST-\d+$/.test(saved) ? null : saved;
}

// Builds an onChange handler for a filter select, persisting the choice to session storage
export function onFilterChange(setter, storageKey) {
  return (e) => {
    const v = e.target.value;
    setter(v === commonStrings.all ? null : v);
    sessionStorage.setItem(storageKey, v);
  };
}

export const DispatchFirst = ['SUPPLY FROM', 'INVOICE NO/DT', 'GRADE', 'PROCESSED AT'];
export const DispatchSecond = ['Density (Gm/Cc)', 'Moisture (%)', 'Browns (%)', 'Blacks (%)', 'Broken & Bits (%)', 'Insected Beans (%)', 'Bleached (%)', 'Husk (%)', 'Sticks (%)', 'Stones (%)', 'Beans Retained On 5mm Mesh During Sieve Analysis'];

export function statusChangePayload(purchaseDetails, currentUserDetails) {
  let payload = {};
  let status =
    (parseInt(purchaseDetails?.details?.status) === 1 || parseInt(purchaseDetails?.details?.status) === 15)
      ? "changeToPendingStatus"
      : parseInt(purchaseDetails?.details?.status) === 3
      ? "changeToclosedStatus"
      : "changeToInprogessStatus";
  if ([3].includes(parseInt(purchaseDetails?.details?.status))) {
    payload = {
      emailid: purchaseDetails?.supplier?.supplier_email,
      type: status,
      po_id: purchaseDetails?.details?.poid,
      createduserid: currentUserDetails.id,
      loggedinuserid: currentUserDetails?.id,
    };
  } else {
    payload = {
      type: status,
      po_id: purchaseDetails?.details?.poid,
      created_user_id: currentUserDetails?.id,
      logged_in_user_id: currentUserDetails?.id,
    };
  }
  return payload;
}
const purchaseOrderStatusStrings = purchaseOrderStrings.statusLabels;

// PO status labels
export const PO_STATUS_LABELS = {
        1: purchaseOrderStatusStrings.new,
        2: purchaseOrderStatusStrings.pending_with_approval,
        5: purchaseOrderStatusStrings.approved,
        6: purchaseOrderStatusStrings.closed,
        16:purchaseOrderStatusStrings.partially_delivered,
        15: purchaseOrderStatusStrings.pending_review,
        14: purchaseOrderStatusStrings.pending_with_general_director,
      };

// Target status id each PO action sends in the updatePoStatus api payload
export const PO_ACTION_TARGET_STATUS = {
  RequestApprove: 2,
  PendingWithGeneralDirector: 14,
  Approve: 5,
  Close: 6,
};

export const PO_ACTION_STATUS_LABEL = {
  RequestApprove: purchaseOrderStatusStrings.pending_with_approval,
  Approve: purchaseOrderStatusStrings.approved,
  Close: purchaseOrderStatusStrings.closed,
  PendingWithGeneralDirector: purchaseOrderStatusStrings.pending_with_general_director,
};

// Builds the payload for the updatePoStatus api
export function updatePoStatusPayload(actionType, purchaseDetails, currentUserDetails) {
  return {
    po_id: purchaseDetails?.details?.poid,
    status: String(PO_ACTION_TARGET_STATUS[actionType]),
    requested_by: currentUserDetails?.id,
  };
}

export function formatGCCompositions(compostion){
  return [
      { composition_name: poDispatchStrings.density, composition_rate: compostion.density },
      { composition_name: poDispatchStrings.moisture, composition_rate: compostion.moisture },
      { composition_name: poDispatchStrings.sound_beans, composition_rate: compostion.soundbeans },
      { composition_name: poDispatchStrings.browns, composition_rate: compostion.browns },
      { composition_name: poDispatchStrings.blacks, composition_rate: compostion.blacks },
      { composition_name: poDispatchStrings.broken_bits, composition_rate: compostion.brokenbits },
      { composition_name: poDispatchStrings.insected_beans, composition_rate: compostion.insectedbeans },
      { composition_name: poDispatchStrings.bleached, composition_rate: compostion.bleached },
      { composition_name: poDispatchStrings.husk, composition_rate: compostion.husk },
      { composition_name: poDispatchStrings.sticks, composition_rate: compostion.sticks },
      { composition_name: poDispatchStrings.stones, composition_rate: compostion.stones },
      { composition_name: poDispatchStrings.mouldy_beans, composition_rate: compostion.mouldy_beans },
      { composition_name: poDispatchStrings.beans_retained, composition_rate: compostion.beansretained }
    ];
}

export const quotesAllocationColumns = [
    {
      label: "Quote No",
      key: "quote_number",
      width: '30%',
    },
    {
      label: "Quote Line No",
      key: "quote_line_number",
      width: '30%',
    },
    {
      label: "Account Name",
      key: "account_name",
      width: '30%',
    },
    {
      label: "Item Name",
      key: "item_name",
      width: '15%',
    },
    {
      label: "Gc Price",
      key: "gc_price",
      width: '10%',
    },
    {
      label: "Balance Qty",
      key: "balance_quantity",
      width: '15%',
    },
  ];

export const DELIVERY_TYPES_WITH_SUFFIX = ["SEZ", "EOU Duggirala"];

export function formFields(props) {
  return [
    {
      sectionTitle: poDispatchStrings.edit_dispatch_details,
      noAccordion: false,
      fields: [
        {
          name: "Expected_Time_Of_Arrival",
          label: poDispatchStrings.eta_date,
          type: "date",
          format: "DD-MM-YYYY",
          minDate: new Date(),
        },
        {
          name: "Shipping_Instructed",
          label: poDispatchStrings.si_check_label,
          type: "checkbox",
        },
        {
          name: "SI_Date",
          label: poDispatchStrings.si_date_label,
          type: "date",
          format: "DD-MM-YYYY",
          disabled: String(props?.siCheck) == "true" ? false : true,
        },
        {
          name: "Port_Date",
          label: poDispatchStrings.port_date_label,
          type: "date",
          format: "DD-MM-YYYY",
          clearable: true,
          disabled: !props?.etaDate,
          maxDate: props?.etaDate ? dayjs(props.etaDate) : null,
        },
      ],
    },
  ];
}
export function defaultDates(res) {
  return {
    Port_Date: convertDayJsToRawFormat(res?.port_date,"YYYY-MM-DD"),
    Shipping_Instructed: String(res?.si_check).toLowerCase() === "true",
    SI_Date: convertDayJsToRawFormat(res?.si_date,"YYYY-MM-DD"),
    Expected_Time_Of_Arrival: convertDayJsToRawFormat(res?.expected_result_date,"YYYY-MM-DD"),
  };
}

export function dispatchFieldAuditConfig() {
  return {
    Shipping_Instructed: {type: "booleanText", label: poDispatchStrings.si_check_label},
  }
}

export const gcTableColumns = [
  { key: "composition_name", label: poDispatchStrings.item },
  { key: "composition_rate", label: poDispatchStrings.composition },
];

export const mrinTableColumns = mapObjectToArray(poDispatchStrings.mrinTableHeaders, {}, "label", "key");

// Document list table has some custom cell rendering
export const documentListNewConfig = {
  acceptMime: "application/pdf",

  docKindFields: {
    "Bill of Lading": { numberKey: docKindFieldsStr.billofladdingnumber, dateKey: docKindFieldsStr.billofladdingdate },
    "Invoice": { numberKey: docKindFieldsStr.invoicenumber, dateKey: docKindFieldsStr.invoicedate },
    "Supplier Contract Copy": { numberKey: docKindFieldsStr.suppliercontractcopynumber, dateKey: docKindFieldsStr.suppliercontractcopydate },
    "Bill of Entry": {
      numberKey: docKindFieldsStr.billofentrynumber,
      dateKey: docKindFieldsStr.billofentrydate,
      conversionKey: docKindFieldsStr.conversationratio,
    },
    "Certificate of Origin": { numberKey: docKindFieldsStr.billofentrynumber, dateKey: docKindFieldsStr.billofentrydate },
    "ICO Certificate of Origin": { numberKey: docKindFieldsStr.billofentrynumber, dateKey: docKindFieldsStr.billofentrydate },
    "Insurance Certificate": { numberKey: docKindFieldsStr.billofentrynumber, dateKey: docKindFieldsStr.billofentrydate },
    "Phytosanitary Certificate": { numberKey: docKindFieldsStr.billofentrynumber, dateKey: docKindFieldsStr.billofentrydate },
    "Fumigation Certificate": { numberKey: docKindFieldsStr.billofentrynumber, dateKey: docKindFieldsStr.billofentrydate },
  },

  columns: [
    { id: "doc_kind", label: docHeaderLabels.documentName, type: "text" },
    { id: "fileName", label: docHeaderLabels.fileName, type: "attachment" },
    { id: "number", label: docHeaderLabels.number, type: "number" },
    { id: "date", label: docHeaderLabels.date, type: "date" },
    { id: "conversionRate", label: docHeaderLabels.conversionRate, type: "conversionRate" },
    { id: "upload", label: docHeaderLabels.upload, type: "checkbox" },
  ],
};

// Based on the document kind, we need to show different editable fields in the table.
export function getEditableFieldDefsForDocKind(docKind) {
  const meta = documentListNewConfig.docKindFields?.[docKind];
  if (!meta) return [];

  const defs = [
    { type: "text", labelKey: "number", fieldKey: meta.numberKey },
    { type: "date", labelKey: "date", fieldKey: meta.dateKey },
  ];

  if (meta.conversionKey) {
    defs.push({ type: "text", labelKey: "conversionRate", fieldKey: meta.conversionKey });
  }

  return defs;
}

// Document list table has some custom cell rendering
export const renderCell = (props) => {
  const colType = props.column?.type;
  if (colType === "number") {
    const defs = props.editableFieldDefsForRow(props.row);
    const numberDef = defs.find((d) => d.labelKey === "number");
    const fieldKey = numberDef?.fieldKey;
    const value = fieldKey ? props.row?.[fieldKey] ?? "" : "";
    if (!props.edit) return value;

    if (!fieldKey) return <></>;
     const dynamicLabel = documentNumberLabelMapStr[props.row?.doc_kind]
    return (
      <TextField
        value={value}
        onChange={(e) => props.onTextFieldChange(props.rowIndex, fieldKey, e.target.value)}
        label={dynamicLabel}
        className={props.globalClasses.w200px}
      />
    );
  }

  if (colType === "conversionRate") {
    const defs = props.editableFieldDefsForRow(props.row);
    const conversionDef = defs.find((d) => d.labelKey === "conversionRate");
    const fieldKey = conversionDef?.fieldKey;
    const value = fieldKey ? props.row?.[fieldKey] ?? "" : "";

    if (!props.edit) return value;

    return fieldKey ? (
      <TextField
        value={value}
        onChange={(e) => props.onTextFieldChange(props.rowIndex, fieldKey, e.target.value)}
        label={dispatchString.documentInfoTableHeaders.conversionRate}
        className={props.globalClasses.w200px}
      />
    ) : (
      <></>
    );
  }

  if (colType === "date") {
    const defs = props.editableFieldDefsForRow(props.row);
    const dateDef = defs.find((d) => d.labelKey === "date");
    const fieldKey = dateDef?.fieldKey;
    const val = fieldKey ? props.row?.[fieldKey] : "";
    if (!props.edit) return val || "";
    let datepickerValue = null;
    if (typeof val === "string") {
      const strictDate = dayjs(val, "DD-MM-YYYY", true);
      datepickerValue = strictDate.isValid() ? strictDate : dayjs(val);
    } else {
      datepickerValue = val || null;
    }
    return fieldKey ? (
      <Template
        payload={[{
          label: dispatchString.documentInfoTableHeaders.date,
          type: "yearDatepicker",
          variant: "outlined",
          value: datepickerValue,
          onChange: (date) => props.onDateFieldChange(props.rowIndex, fieldKey, date),
          sm: 12,
          slotProps: {
            textField: {
              error: false,
            },
            field: {
              clearable: true,
            },
          },
        }]} />
    ) : (
      <></>
    );
  }

  if (colType === "checkbox") {
    return (
      <CheckBox
        checked={Boolean(props.row?.[props.column?.id])}
        name={props.row?.[props.column?.id]}
        disabled={true}
      />
    );
  }

  if (colType === "text") {
    return props.row?.[props.column?.id] ?? "";
  }

  if (colType === "attachment") {
    if (props.row?.file_name) {
      const link = (
        <a onClick={() => props.onPreviewAttachment(props.row.file_name)}>
          {props.row?.document_name || ""}
        </a>
      );
      if (!props.edit) return link;
      return (
        <Grid container className={`${props.globalClasses.flexAlignCenter} ${props.globalClasses.flexNoWrap} ${props.globalClasses.gap6}`}>
          <Grid item>{link}</Grid>
          <Grid item className={props.globalClasses.flexAlignCenter}>
            <Tooltip title={commonStrings.delete} arrow>
              <IconButton
                size="small"
                className={props.globalClasses.clearSearch}
                onClick={props.handleDeleteConfirmation(props.row)}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      );
    }

    if (!props.edit) return "";

    if (props.row?.upload) {
      return (
        <Grid container className={`${props.globalClasses.flexAlignCenter} ${props.globalClasses.flexNoWrap} ${props.globalClasses.gap6}`}>
          <Grid item>{props.row?.pending_file_name || ""}</Grid>
          <Grid item className={props.globalClasses.flexAlignCenter}>
            <Tooltip title={commonStrings.remove} arrow>
              <IconButton
                size="small"
                className={props.globalClasses.clearSearch}
                onClick={() => props.handleRemovePendingUpload(props.row)}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      );
    }

    return (
      <TextField
        inputProps={{ accept: documentListNewConfig.acceptMime }}
        type="file"
        onChange={(e) => props.handleFileInputChange(e, props.row)}
        className={props.globalClasses.w200px}
      />
    );
  }

  if (colType === "actions") {
    if (!props.row?.file_name) return "";
    return (
      <>
        {props.edit && (
          <Tooltip title={commonStrings.delete} arrow>
            <span>
              <DeleteIcon
                className={props.globalClasses.clearSearch}
                onClick={props.handleDeleteConfirmation(props.row)}
              />
            </span>
          </Tooltip>
        )}
      </>
    );
  }
  return "";
};

const dispatchColumnTypes = {
  dispatch_id: "link",
  dispatch_date: "date",
  port_date: "date",
  dispatch_quantity: "commaSeparation",
  delivered_quantity: "commaSeparation",
  balance_quantity: "commaSeparation",
};
export const GetDispatchGridColumns = (poid, activeStep) => {
  const result = [];
  for (const id in dispatchTableHeaders) {
    const label = dispatchTableHeaders[id];
    let colDef;
    const colType = dispatchColumnTypes[id];
    if (colType === "link") {
      colDef = {
        title: label,
        dataIndex: id,
        key: id,
        render: (text, record) => (
          <Link to={`/purchase-order/${encodeURIComponent(poid)}/dispatch/${encodeURIComponent(text)}/view?activeStep=${activeStep}`}>{text}</Link>
        ),
      };
    } else if (colType === "commaSeparation") {
      colDef = {
        title: label,
        dataIndex: id,
        key: id,
        type: colType,
        render: (text, row) => {
          const num = Number(text);
          return numberWithCommas(num.toFixed(3));
        }
      };
    } else if (colType === "date") {
      if (id === "dispatch_date") {
        colDef = {
          title: label,
          dataIndex: id,
          key: id,
          type: colType,
          render: (text, row) => {
            if (row?.dispatch_date) {
              return formatDateSafe(row?.dispatch_date, "MMM-YYYY");
            }
          }
        };
      } else {
        colDef = {
          title: label,
          dataIndex: id,
          key: id,
          type: colType,
          render: formatDateSafe,
        }
      }
    }
    else {
      colDef = {
        title: label,
        dataIndex: id,
        key: id,
      };
    }
    if (colDef) result.push(colDef);
  }
  return result;
};

// export const shippingInstructedCheckBox = (dispatchDetails, handleChangeShipping) => {
//   return ([
//     {
//       label: poDispatchStrings.si_check_label,
//       type: "checkbox",
//       checked: dispatchDetails?.si_check || false,
//       onChange: (e) => handleChangeShipping(e),
//       sm: 12,
//       disabled: true,
//     },
//   ])
// };

// Builds DynamicView's `otherTabs` prop for Dispatch/DispatchView.tsx.
export const getOtherTabs = (dispatchId) => [
  {
    label: dispatchInfoStrings.vehicle.vehicleInformationTab,
    index: "vehicles",
    visible: true,
    component: <VehicleInformationTab dispatchId={dispatchId} />,
  },
];

// ── Dispatch Details view helpers ─────────────────────────────────────────────

// Roles permitted to edit dispatch details
export const EDIT_DISPATCH_ROLES = [
  roles.managerPurchaseGC,
  roles.GeneralManagerPurchase,
  roles.managingDirector,
  roles.admin,
  roles.purchaseExecutiveGC,
];

// Roles blocked from editing documents
export const RESTRICTED_DOCUMENT_EDIT_ROLES = [
  roles.Auditor,
  roles.executiveLeadership,
  roles.viewOnly,
  roles.readOnly,
  roles.managerfinance,
  roles.Chairman,
];

// Builds the Template-ready payload for the Dispatch Details view section
const dispatchViewFormatConfig = {
  dispatch_date: (v) => formatDateSafe(v, "MMMM-YYYY") || "-",
  dispatch_quantity: (v) => numberWithCommas(v),
  delivered_quantity: (v) => numberWithCommas(v) || "-",
  port_date: (v) => formatDateSafe(v) || "-",
  eta_date: (v) => formatDateSafe(v) || "-",
  si_date: (v) => formatDateSafe(v) || "-",
  si_check: (v) => v || false,
};

export const getDispatchViewInfo = (dispatchDetails, etaDate) => {
  const data = { ...dispatchDetails, eta_date: etaDate };
  const fields = purchaseOrderStrings.dispatch.dispatch_dtls;
  const items = [];
  for (const key in fields) {
    const value = dispatchViewFormatConfig[key]
      ? dispatchViewFormatConfig[key](data?.[key])
      : (data?.[key] ?? null);
    const item = { label: fields[key], value };
    if (key === "si_check") {
      item.type = "checkbox";
      item.labelSm = 3;
      item.valueSm = 3;
    }
    items.push(item);
  }
  return viewDataStructure(items);
};

// Builds the Template-ready payload for the "related dispatch date" edit field
export const getRelatedDispatchDatePayload = (dispatchDate, onChange) => [
  {
    label: poDispatchStrings.dispatch_date,
    type: "datePicker",
    value: dispatchDate,
    onChange,
    sm: 12,
  },
];

// ContractReports filter helpers

export const getContractReportCompanyFilterList = (role) => getCompanyFilterList(role);

export const isContractReportCompanyFilterDisabled = (role) => isCompanyRestrictedRole(role);

// Builds the Template-ready payload for the ContractReports dispatch date range filters
export const getContractReportDateRangePayload = (allFiters, changeFilter) => [
  {
    label: purchaseOrderStrings.contractReport.dispatchDateFrom,
    type: "yearDatepicker",
    value: allFiters?.dispatch_from || null,
    onChange: (date) => changeFilter(date, 'dispatch_from'),
  },
  {
    label: purchaseOrderStrings.contractReport.dispatchDateTo,
    type: "yearDatepicker",
    value: allFiters?.dispatch_to || null,
    onChange: (date) => changeFilter(date, 'dispatch_to'),
  },
];

// insurance dropdown options
export const insuranceOptions = createColumnsFromBundle(purchaseOrderStrings.static_dropdowns.insurance_options, 'dropdownpairs')


const received_qty_table_headers = purchaseOrderStrings.view.received_quantity_info_tab.received_quantity_table;

export const receivedQtyTableHeaders = () => {
  const result = [];
  for (const id in received_qty_table_headers) {
    result.push({
      key: id,
      label: received_qty_table_headers[id],
    });
  }
  return result;
};

// PO status ids: 1 New, 2 Pending with approval, 5 Approved, 6 Partially delivered, 16 Delivered.
export function getPurchaseOrderStatusSteps(status, companyName, totalQuantity, balanceQuantity, generalDirectorStatusApplicable) {
  const st = parseInt(status);
  const isNCL = companyName === "NCL";
  // General Director sign-off only applies to NCL POs, and only while the backend hasn't ruled it out
  // (general_director_status_applicable is null until a manager approves, then true/false).
  const showGDStep = isNCL && generalDirectorStatusApplicable !== false;

  const isNew = st === 1;
  const isPendingReview = isNCL && st === 15;
  const isPendingApproval = st === 2;
  const isPendingGD = showGDStep && st === 14;
  const isApproved = st === 5;
  const isPartiallyDelivered = st === 16;
  const isClosed = st === 6;
  const isCompleted = st === 17;

  const total = parseFloat(totalQuantity);
  const balance = parseFloat(balanceQuantity);
  // when closed, quantities decide whether it was fully delivered before closing or closed while still partially delivered
  const isFullyDeliveredClosed = isClosed && balance === total;
  const isPartiallyDeliveredClosed = isClosed && balance !== total && balance > 0;

  const isBeforeReview = isNew;
  const isBeforePendingApproval = isNew || isPendingReview;
  const isBeforeGD = isNew || isPendingReview || isPendingApproval;
  const isBeforeApproved = isNew || isPendingReview || isPendingApproval || isPendingGD;

  const typeNew = isNew ? "inprogress" : isFullyDeliveredClosed ? "incomplete" : "completed";
  const typePendingReview = isPendingReview ? "inprogress" : isBeforeReview || isFullyDeliveredClosed ? "incomplete" : "completed";
  const typePendingApproval = isPendingApproval ? "inprogress" : isBeforePendingApproval || isFullyDeliveredClosed ? "incomplete" : "completed";
  const typePendingGD = isPendingGD ? "inprogress" : isBeforeGD || isFullyDeliveredClosed ? "incomplete" : "completed";
  const typeApproved = isBeforeApproved || isFullyDeliveredClosed ? "incomplete" : "completed";
  const typeDelivery = isBeforeApproved || isApproved || isFullyDeliveredClosed
    ? "incomplete"
    : isPartiallyDelivered || isPartiallyDeliveredClosed
    ? "inprogress"
    : "completed";
  const showPartiallyDelivered = isPartiallyDelivered || isPartiallyDeliveredClosed;

  const steps = [{ label: purchaseOrderStrings.forms.new, type: typeNew }];
  if (isNCL) steps.push({ label: purchaseOrderStrings.pendingReview, type: typePendingReview });
  steps.push({ label: purchaseOrderStrings.forms.pendingWithApproval, type: typePendingApproval });
  if (showGDStep) steps.push({ label: commonStrings.pendingWithGeneralDirector, type: typePendingGD });
  steps.push(
    { label: purchaseOrderStrings.forms.approved, type: typeApproved },
    { label: showPartiallyDelivered ? purchaseOrderStrings.forms.partiallyDelivered : purchaseOrderStrings.forms.delivered, type: typeDelivery },
    {
      label: isClosed ? purchaseOrderStrings.forms.closed : purchaseOrderStrings.forms.completed,
      type: isClosed ? "rejected" : isCompleted ? "completed" : "incomplete",
    },
  );

  return steps;
}

// hide status from ccl 
const ALWAYS_HIDDEN_PO_STATUS_LOV_IDS = ["PO-ST-1"];
const CCL_HIDDEN_PO_STATUS_LOV_IDS = ["PO-ST-3", "PO-ST-5"];

/** @returns {import('./types').StatusOption[]} */
export function getPurchaseOrderStatusFilterList(statusData, company) {
  return (statusData || []).reduce((options, item) => {
    if (ALWAYS_HIDDEN_PO_STATUS_LOV_IDS.includes(item.lov_id)) return options;
    if (company === "CCL" && CCL_HIDDEN_PO_STATUS_LOV_IDS.includes(item.lov_id)) return options;
    options.push({ label: item.lov_name, value: item.lov_name });
    return options;
  }, []);
}

// Create Purchase Order access
export function canCreatePO(role) {
  return ![
    roles.purchaseExecutiveGCview,
    roles.managerPurchaseGC,
    roles.accountsManager,
    roles.managerGCStores,
    roles.executiveLeadership,
    roles.viewOnly,
    roles.readOnly,
    roles.managerfinance,
    roles.Chairman,
    roles.Auditor,
    roles.ceo,
    roles.factorymanager,
    roles.qcManager,
    roles.qcHead].includes(role);
}

// Roles allowed to approve a PO
export function canApprovePO(role) {
  return [roles.managerPurchaseGC, roles.managingDirector, roles.admin].includes(role);
}

// "Category" filter options for the PO list
export const PO_CATEGORY_FILTER_LIST = [
  { label: commonStrings.all, value: commonStrings.all },
  { label: commonStrings.import, value: commonStrings.import },
  { label: commonStrings.domestic, value: commonStrings.domestic },
];

const poGridColumns = purchaseOrderStrings.poGrid;

export const PO_DATE_FORMAT = "DD-MM-YYYY";
export const PO_SHIPMENT_MONTH_FORMAT = "MM-YYYY";

// DynamicForm wraps its fields in its own LocalizationProvider, so the "date" fields below don't need one supplied from the caller.
// Field definitions for the PO grid's shipment-month filter modal.
/**
 * @param {Date | string | null} [minDate]
 * @returns {import('./types').ShipmentMonthFilterSection[]}
 */
export const getShipmentMonthFilterSectionDetails = (minDate) => [
  {
    fields: [
      {
        name: "shipment_month_from",
        label: poForms.shipmentMonthFrom,
        type: "date",
        format: PO_SHIPMENT_MONTH_FORMAT,
        views: ["year", "month"],
        clearable: true,
        md: 12,
      },
      {
        name: "shipment_month_to",
        label: poForms.shipmentMonthTo,
        type: "date",
        format: PO_SHIPMENT_MONTH_FORMAT,
        views: ["year", "month"],
        minDate,
        disabled: !minDate,
        clearable: true,
        md: 12,
      },
    ],
  },
];

// Labels for export_extra_fields come from purchaseOrderStrings.export_extra_fields (StringBundle).
export const PO_EXPORT_INSERT_POSITIONS = [
  { key: "company_name", position: 0 },
  { key: "entity_name", position: 5 },
  { key: "po_sub_category", position: 6 },
  { key: "po_category", position: 7 },
];

// PO grid columns
/** @returns {import('./types').PoColumn[]} */
export function getPurchaseOrderColumns() {
  const columns = [];
  for (const id of Object.keys(poGridColumns)) {
    const title = poGridColumns[id];

    if (id === "po_no") {
      columns.push({
        title,
        dataIndex: id,
        key: id,
        width: "12%",
        render: (text, record) => (
          <Link to={`/purchase-order/${encodeURIComponent(record.po_no)}/view?tab=details`}>
            {text}
          </Link>
        ),
      });
      continue;
    }

    const col = { title, dataIndex: id, key: id, width: "11%" };
    if (id === "po_date") {
      col.sorter = filterTableSorter(id, "date", moment.ISO_8601);
      col.render = (text) => dateFormat(text, PO_DATE_FORMAT);
    } else if (id === "total_quantity" || id === "total_price") {
      col.render = (text) => formatNumber(text, 3);
    } else if (id === "email_delivered") {
      col.render = (text, row) => (
        <CheckBox checked={row.email_delivered} name={row.email_delivered} disabled />
      );
    }
    columns.push(col);
  }
  return columns;
}

export const requestApprovalbtnrestrictedRoles = [
  roles.purchaseExecutiveGCview,
  roles.Auditor,
  roles.executiveLeadership,
  roles.viewOnly,
  roles.readOnly,
];

// PO PreShipment Sample - parent grid columns
export const GetPOPreShipmentMainCols = () =>
  mapObjectToArray(purchaseOrderStrings.poPreShipmentGrid, {}, "headerName", "field").map((col) => {
    if (col.field === "record_id") {
      return {
        ...col,
        render: (row) => (
          <Link to={"/pre-shipment-sample/" + encodeURIComponent(row.id) + "/detail?type=pss&tab=details"}>
            {row.record_id}
          </Link>
        ),
      };
    }
    if (col.field === "sample_request_date") {
      return {
        ...col,
        render: (row) => dateFormat(row.sample_request_date, "DD-MM-YYYY"),
      };
    }
    return col;
  });

// PO PreShipment Sample - child grid columns
export const GetPOPreShipmentSubCols = () =>
  mapObjectToArray(purchaseOrderStrings.poPreShipmentLineGrid, {}, "headerName", "field").map((col) => {
    if (col.field === "record_id") {
      return {
        ...col,
        render: (row) => (
          <Link to={"/pre-shipment-sample/" + encodeURIComponent(row.pss_id) + "/" + encodeURIComponent(row.id) + "/detail?type=pss&tab=details"}>
            {row.record_id}
          </Link>
        ),
      };
    }
    if (col.field === "expected_result_date") {
      return {
        ...col,
        render: (row) => dateFormat(row.expected_result_date, "DD-MM-YYYY"),
      };
    }
    return col;
  });

// Returns the domestic tax options not already used by another row in tempTaxChargesList (excluding the row at `index`).
// `excludedTaxIds` lets a caller always exclude specific tax_id values (e.g. Edit PO treats "1" as a placeholder, not a real selection).
export function getAvailableTaxOptions(tempTaxChargesList, domesticTaxesList, index, excludedTaxIds = []) {
  const usedTaxIds = new Set(excludedTaxIds);
  for (const [i, c] of tempTaxChargesList.entries()) {
    if (i !== index && c.tax_id) usedTaxIds.add(c.tax_id);
  }

  const availableOptions = [];
  for (const opt of domesticTaxesList || []) {
    if (!usedTaxIds.has(opt.value)) availableOptions.push(opt);
  }
  return availableOptions;
}

export const getDestinationPortsByCompany = (ports = [], companyName) => {
  const isNCL = companyName === "NCL";
  return ports?.filter((port) =>
    isNCL ? port?.value == '3' : port?.value !== '3'
  );
};
